<template>
  <div class="pa-4">
    <h4>Integrações</h4>
    <v-card outlined>
      <v-card-title class="pb-4"> Omie </v-card-title>
      <v-divider></v-divider>

      <v-card-text>
        <h6 style="font-size: 1.2rem">Importar clientes</h6>
        <p class="text-body-2">Importe clientes da Omie para o sistema.</p>
        <v-btn v-if="!importStatus.isImportingClients?.isImporting" color="primary" @click="importClients" :loading="loading">
          Importar
        </v-btn>
        <v-progress-linear v-else :value="(importStatus.isImportingClients.progress / importStatus.isImportingClients.total) * 100" :max="100" />

        <v-divider class="my-4"></v-divider>

        <h6 style="font-size: 1.2rem">Importar contas correntes</h6>
        <p class="text-body-2">Importe contas correntes da Omie para o sistema.</p>
        <v-btn v-if="!importStatus.isImportingBanks?.isImporting" color="primary" @click="importBanks" :loading="loading">
          Importar
        </v-btn>
        <v-progress-linear v-else :value="(importStatus.isImportingBanks.progress / importStatus.isImportingBanks.total) * 100" :max="100" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import INTEGRATIONS_SERVICE from '@/services/integrations'
export default {
  name: 'Integrations',
  data() {
    return {
      importStatus: {
        isImportingClients: false,
        isImportingBanks: false,
      },
      loading: false,
    }
  },
  methods: {
    async importClients() {
      try {
        this.loading = true
        const response = await INTEGRATIONS_SERVICE.omie.importClients()
        this.importStatus.isImportingClients = {
          isImporting: true,
        }
        this.loading = false
        this.updateClientsImportStatus()
      } catch (error) {
        console.error('Erro ao importar clientes:', error)
        this.loading = false
      }
    },
    async getClientsImportStatus() {
      try {
        const response = await INTEGRATIONS_SERVICE.omie.importClientsStatus()
        this.importStatus.isImportingClients = response
      } catch (error) {
        console.error('Erro ao obter status da importação:', error)
      }
    },
    updateClientsImportStatus() {
      if (this.importStatus.isImportingClients?.isImporting) {
        this.getClientsImportStatus()
        setTimeout(() => {
          this.updateClientsImportStatus()
        }, 500)
      }
    },
    async importBanks() {
      try {
        this.loading = true
        const response = await INTEGRATIONS_SERVICE.omie.importBanks()
        this.importStatus.isImportingBanks = {
          isImporting: true,
        }
        this.loading = false
        this.updateBanksImportStatus()
      } catch (error) {
        console.error('Erro ao importar bancos:', error)
        this.loading = false
      }
    },
    async getBanksImportStatus() {
      try {
        const response = await INTEGRATIONS_SERVICE.omie.importBanksStatus()
        this.importStatus.isImportingBanks = response
      } catch (error) {
        console.error('Erro ao obter status da importação de bancos:', error)
      }
    },
    updateBanksImportStatus() {
      if (this.importStatus.isImportingBanks?.isImporting) {
        this.getBanksImportStatus()
        setTimeout(() => {
          this.updateBanksImportStatus()
        }, 500)
      }
    },
  },
  async mounted() {
    await this.getClientsImportStatus()
    this.updateClientsImportStatus()
    await this.getBanksImportStatus()
    this.updateBanksImportStatus()
  },
}
</script>
